/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Sep-22
 *
 * bestgob-client - auth.api.js
 **/

import {httpClient, httpClientBackend} from "./http-client";
import {toFormData} from "../core/utils";

const postLogin = (request) => httpClient.post('/access_token', request)

const postRefreshLogin = (refreshToken) => httpClient.post('/refresh_token', {
    grant_type: 'refresh_token',
    refresh_token: refreshToken
})

const postRegister = (data) => httpClient.post('usuario_registrar', data)

/**
 * Obtiene informacion del perfil de usuario
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
const getUserProfile = () => httpClient.get('/usuario_perfil')

/**
 * Actualiza el perfil de usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const updateProfile = (data) => httpClient.post('/usuario_actualizar', data)

/**
 * Acutualiza la imagen de perfil del usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const updateProfileAvatar = (data) => httpClient.post('/usuario_actualizar_avatar', toFormData(data))

/**
 * ACtualiza contrasenia dentro del perfil del usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const updatePassword = (data) => httpClient.post('recover_password', data)

/**
 * Inicia la recuperacion de contrasenia del usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const forgotPasswordRequest = (data) => httpClient.post('usuario_recuperar_contrasena/iniciar', data)

/**
 * Finaliza la recuperacion de contrasenia, creando una nueva para el usuario usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const newPassword = (data) => httpClient.post('usuario_recuperar_contrasena/finalizar', data)

/**
 * Valida que el username y el email sean unicos en la base de datos
 *
 * @param username
 * @param email
 * @returns {Promise<AxiosResponse<any>>}
 */
const postValidateUniqueCredentials = (data) => httpClient.post('/valid_unique_values', data)

/**
 * Valida que las credenciales de google no sean utilizados en algun registro previo.
 *
 * @param username
 * @param email
 * @returns {Promise<AxiosResponse<any>>}
 */
const postValidateGoogleCredentials = (username, email) => httpClient.post('/usuario_google_registrado', toFormData({
    username: username,
    email: email,
    client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID
}))

/**
 * Valida que las credenciales de facebook no sean utilizados en algun registro previo.
 *
 * @param username
 * @param email
 * @returns {Promise<AxiosResponse<any>>}
 */
const postValidateFacebookCredentials = (username, email) => httpClient.post('/usuario_facebook_registrado', toFormData({
    username: username,
    email: email,
    client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID
}))

/**
 * Reenvia el codigo de verificacion para el usuario en sesion
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
const sendVerificationCode = () => httpClient.post('/usuario_verificar_registro/enviar_codigo', {})

/**
 * Envia el codigo de verificacion de la cuenta en sesion
 *
 * @param request
 * @returns {Promise<AxiosResponse<any>>}
 */
const verifyRegister = (request) => httpClient.post('/usuario_verificar_registro/validar_codigo', request)

/**
 * Verifica si el periodo de prueba del usuario aun sigue vigente
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
const verifyTryAvailable = () => httpClient.post('/usuario_verificar_registro/periodo_prueba', {})

/**
 * Verifica numero telefonico, solicitando un numero de confirmacion
 *
 * * @returns {Promise<AxiosResponse<any>>}
 */
const verifyPhoneNumber = (request) => httpClientBackend.post('/send_phone', request)

/**
 * Confirma el numero de verificacion que llega por sms
 *
 * * @returns {Promise<AxiosResponse<any>>}
 */
const confirmPhoneNumber = (request) => httpClientBackend.post('/phone_confirm', request)

/**
 * Busca una curp por medio de los datos personales del usuario
 *
 * * @returns {Promise<AxiosResponse<any>>}
 */
const searchCurpByName = (request) => httpClientBackend.post('user_verify_curp', request)

export {
    postLogin,
    postRegister,
    postRefreshLogin,
    getUserProfile,
    updateProfile,
    updatePassword,
    postValidateUniqueCredentials,
    postValidateGoogleCredentials,
    postValidateFacebookCredentials,
    updateProfileAvatar,
    forgotPasswordRequest,
    newPassword,
    sendVerificationCode,
    verifyRegister,
    verifyTryAvailable,
    verifyPhoneNumber,
    confirmPhoneNumber,
    searchCurpByName
}